import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { MIXPANEL_APP_NAME } from 'constants/mixpanel'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { getOperationCode } from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToEvent = (state, action) => {
  const { productId, productName } = action.payload

  return {
    'Click Name': 'Click on pin',
    'Operation Code': getOperationCode(state),
    'Page Name': 'See on the map',
    'Product': productName,
    'Product ID': productId,
    'Type': MIXPANEL_APP_NAME
  }
}

const clickMapPinTrackingEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.map.CLICK_MAP_PIN),
  tap(action => {
    const eventName = 'Click'

    track(eventName, mapStateToEvent(state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickMapPinTrackingEpic
